import React from 'react';
import Notifications from '../Notifications';
import s from './LiveNotifications.scss';
const LiveNotifications = ()=>/*#__PURE__*/ React.createElement(Notifications, {
        wrapperClassName: s['root'],
        animatorClassName: s['animator'],
        queueName: "live"
    });
LiveNotifications.displayName = 'LiveNotifications';
export default LiveNotifications;

//# sourceMappingURL=LiveNotifications.js.map